import React from 'react';
import PropTypes from "prop-types";
import FieldScreenComponent from "../FieldScreenComponent";
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useContextMenu} from "../../../../../Hooks";
import {Tooltip} from "@material-ui/core";

const useStyles = makeStyles(() => ({
    menuItem: {
        padding: "0px 3px",
        minWidth: 300,
    },
    groupWrapper: {
        position: 'relative',
        minHeight: '30px',
        marginLeft: "10px"
    },
    groupWrapperArray: {
        background: '#7b7b7b',
        position: 'relative'
    }
}));
const FieldsInfinity = (props) => {
    const {
        element: {properties: {path, isArray, parentSchema}},
        globalValues, element, addGroup, removeGroup, addNested, screenName
    } = props;
    const {onOpen, ContextMenu} = useContextMenu({
        addBefore: addGroup,
        addAfter: addGroup,
        remove: removeGroup
    });
    const classes = useStyles();
    const currentValues = findByString(globalValues.param[screenName], path);
    const isHaveCurrentValues = currentValues ? Array.isArray(currentValues) ? currentValues.length : Boolean(currentValues) : currentValues;
    function onOpenContext(e, path, arrayIndex) {
        onOpen(e, path + '.' + arrayIndex, path, arrayIndex)
    }

    return (
        <div className={classes.groupWrapper}>
            <ContextMenu/>
            <>
                {!isHaveCurrentValues && (
                    <Tooltip title={'Create new group'}>
                        <IconButton size={"small"} onClick={() => addNested(path, isArray)}>
                            <Icon fontSize={"small"}>
                                subdirectory_arrow_right
                            </Icon>
                        </IconButton>
                    </Tooltip>
                )}
                {currentValues && (
                    isArray ? (
                        <InfinityGroupArray
                            element={element}
                            path={path}
                            currentValues={currentValues}
                            globalValues={globalValues}
                            onOpenContext={onOpenContext}
                            addNested={addNested}
                            isArray={isArray}
                            parentSchema={parentSchema}
                        />
                    ) : (
                        <InfinityGroup
                            parentSchema={parentSchema}
                            globalValues={globalValues}
                            currentValues={currentValues}
                            path={path}
                            element={element}
                        />
                    )
                )}
            </>
        </div>
    )
};

FieldsInfinity.propTypes = {
    element: PropTypes.object.isRequired
};
export default JsonScreenHoc(FieldsInfinity);

const NewInfinity = JsonScreenHoc((props) => {
    return (
        <FieldsInfinity
            element={props.element} parentSchema={props.parentSchema}
            arrayIndex={props.arrayIndex}
            {...props}
        />
    )
});


const useInfinityGrArrayStyles = makeStyles(() => ({
    arrayBtn: {
        position: 'absolute',
        left: -21
    }
}));
const InfinityGroupArray = (props) => {
    const {currentValues, parentSchema, path, isArray, onOpenContext, addNested, element} = props;
    const classes = useInfinityGrArrayStyles();
    return (
        currentValues.map((value, valueIndex) => {
            return (
                <>
                    <IconButton size={"small"}
                                className={classes.arrayBtn}
                                onClick={(e) => currentValues ?
                                    onOpenContext(e, path, valueIndex) :
                                    addNested(path, isArray)}
                    >
                        <Icon fontSize={"small"}>
                            add
                        </Icon>
                    </IconButton>
                    {parentSchema.map((item, index) => {
                        if (item.type === 'field') {
                            return <FieldScreenComponent
                                key={index}
                                field={{
                                    ...item,
                                    properties: {
                                        ...item.properties,
                                        path: `${path}.${valueIndex}.${item.properties.name}`
                                    }
                                }}
                            />
                        }
                        if (item.type === 'fieldInfinity') {
                            return <NewInfinity
                                key={index}
                                element={{
                                    ...element,
                                    properties: {
                                        ...element.properties,
                                        path: `${element.properties.path}.${valueIndex}.${element.properties.field.name}`
                                    }
                                }}
                                parentSchema={parentSchema}
                                arrayIndex={valueIndex}
                            />
                        }
                    })}
                </>
            )
        })
    )
};
InfinityGroupArray.propTypes = {
    currentValues: PropTypes.array,
    parentSchema: PropTypes.array,
    path: PropTypes.string,
    isArray: PropTypes.bool,
    onOpenContext: PropTypes.func,
    addNested: PropTypes.func,
    element: PropTypes.object,
    globalValues: PropTypes.object
};


const InfinityGroup = ({parentSchema, currentValues, element, path, globalValues}) => {
    return (
        <>
            {parentSchema.map((item, index) => {
                if (item.type === 'field') {
                    return <FieldScreenComponent
                        key={index}
                        globalValues={globalValues}
                        field={{
                            ...item,
                            properties: {
                                ...item.properties,
                                path: `${path}.${item.properties.name}`
                            }
                        }}
                    />
                }
            })}
            {currentValues && (
                <NewInfinity
                    element={{
                        ...element,
                        properties: {
                            ...element.properties,
                            path: `${element.properties.path}.${element.properties.field.name}`
                        }
                    }}
                    parentSchema={parentSchema}
                />
            )}
        </>
    )
};
InfinityGroup.propTypes = {
    parentSchema: PropTypes.array,
    currentValues: PropTypes.array,
    element: PropTypes.object,
    path: PropTypes.string,
    globalValues: PropTypes.object
};